<template>
    <div>
        <loading-block v-if="isDataLoading"/>
        <div v-else>
            <info-message status="success" v-if="messageSuccess">L'attestation a bien été envoyée</info-message>
            <div v-if="family.current_payments.length > 0">
                <h1>Paiements</h1>
                <rich-table-recap :payments="family.current_payments">
                </rich-table-recap>
<!--                <div  class="card payment-infos" style="margin-bottom: 16px;">-->
<!--                    Lors de la permanence, un chèque  de caution de 30€ vous sera demandé pour l'utilisation des costumes.-->
<!--                </div >-->
                <section class="card payment-infos" v-if="family.current_payments[0].payment_type != 'Éspèces'">
                    <div v-if="family.current_payments[0].payment_type == 'Virement' ">
                        <H3>Paiement par virement bancaire</H3>
                        <p style="margin-top: 1rem;">IBAN: FR76 1027 8035 2500 0825 1174 202</p>
                        <p style="margin-top: 1rem;">Veuillez nous communiquer une preuve de virement via la colonne "justificatif".</p>
                        <uni-button v-if="canCopyText" ref="button" class="button--small button--secondary"
                                    @click.native="copyText">{{copy}}
                        </uni-button>
                    </div>
                    <div v-if="family.current_payments[0].payment_type == 'Chèque' ">
                        Vous devez remplir les chèques à l'ordre de Rich'en danse.
                    </div>
                </section>
                <div v-if="family.current_payments[0].status !== false">
<!--                  TODO : le remettre quand on aura la signature du président-->
<!--                    <uni-loading-button style="margin-top: 1rem;" @click.native="openCeModal()"-->
<!--                                        :is-disable="loadCe"-->
<!--                                        text="Recevoir l'attestation CE par e-mail"></uni-loading-button>-->

                </div>
            </div>
            <div v-else>
                <section v-show="!isPaymentSectionVisible">
                    <div class="title">
                        <h1>Paiements</h1>
                        <div class="no-courses" v-if="noCourse">
                            <img src="../assets/img/illustrations/no_courses.svg"/>
                            <p>Vous retrouverez ici toutes les informations liées à vos paiements, une fois que vous
                                vous serez inscrit à un ou plusieurs cours de danse.</p>
                        </div>
                        <div v-else>
                            <rich-table :users="family.users.filter(el => el.is_dancer && el.current_courses.length > 0)"/>
                            <uni-button @click.native="openModal = true">Préparer mon paiement</uni-button>
                        </div>

                    </div>
                </section>
                <section v-show="isPaymentSectionVisible" class="payment">
                    <img src="../assets/img/illustrations/i-payment-type.svg" alt="">
                    <div>
                        <h3>Voulez-vous payer à l'année ou par trimestre ?</h3>
                        <beautifull-input-radio label="Annuel"
                                                id="recurannual"
                        >
                            <input v-model="paymentRecurrence"
                                   type="radio"
                                   id="recurannual"
                                   value="annual"
                            >
                        </beautifull-input-radio>
                        <beautifull-input-radio label="Trimestriel"
                                                id="recurtrim"
                        >
                            <input v-model="paymentRecurrence"
                                   type="radio"
                                   id="recurtrim"
                                   value="trim"
                            >
                        </beautifull-input-radio>
                    </div>
                    <div>
                        <h3 v-if="paymentRecurrence !== ''">Comment souhaitez-vous payer ?</h3>
                        <div v-if="paymentRecurrence === 'annual'">
                            <beautifull-input-radio label="Virement bancaire"
                                                    id="annualTypeVirement"
                            >
                                <input v-model="paymentType"
                                       type="radio"
                                       id="annualTypeVirement"
                                       value="virement"
                                >
                            </beautifull-input-radio>
                            <beautifull-input-radio label="Chèque"
                                                    id="annualTypeChèque"
                            >
                                <input v-model="paymentType"
                                       type="radio"
                                       id="annualTypeChèque"
                                       value="cheque"
                                >
                            </beautifull-input-radio>
                            <beautifull-input-radio label="Espèce"
                                                    id="annualTypeCash"
                            >
                                <input v-model="paymentType"
                                       type="radio"
                                       id="annualTypeCash"
                                       value="cash"
                                >
                            </beautifull-input-radio>
                        </div>
                        <div v-if="paymentRecurrence === 'trim'">
                            <beautifull-input-radio label="Chèque"
                                                    id="trimTypeChèque"
                            >
                                <input v-model="paymentType"
                                       type="radio"
                                       id="trimTypeChèque"
                                       value="cheque"
                                >
                            </beautifull-input-radio>
                        </div>
                    </div>
                    <uni-loading-button @click.native="createPayment" :is-disable="loadingPrice"
                                        text="Préparer mon paiement" v-if="paymentType !== ''">
                    </uni-loading-button>
                </section>
            </div>
            <pop-from-bottom :open="openModal" title="Préparation du paiement" @close="openModal = false">
                <template slot="content">
                    <p>Vous êtes sur le point de préparer votre paiement. Vous ne pourrez plus vous inscrire ou
                        désinscrire à des cours.</p>
                </template>

                <template slot="bottom">
                    <div class="action-button">
                        <uni-loading-button :is-disable="loading" text="Continuer"
                                            @click.native="startPayment">
                        </uni-loading-button>

                    </div>
                </template>
            </pop-from-bottom>
            <pop-from-bottom title="Attestation CE" :open="ceModal" @close="ceModal = false">
                <template slot="content">
                    <div>
                        <uni-input-container label="adresse e-mail" id="email">
                            <uni-input id="email" v-model="family.email" :val="family.email" width="auto"></uni-input>
                        </uni-input-container>
                        <uni-loading-button @click.native="downloadCe()" :is-disable="buttonCe"
                                            text="Envoyer"></uni-loading-button>
                    </div>
                </template>
                <template slot="bottom">

                </template>
            </pop-from-bottom>
        </div>
    </div>
</template>

<script>
    import LoadingBlock from "../components/c-blocks/LoadingBlock";
    import RichTable from "../components/c-blocks/RichTablePayment";
    import {mapGetters} from 'vuex'
    import UniButton from "../components/a-elements/UniButton";
    import BeautifullInputRadio from "../components/a-elements/BeautifullInputRadio";
    import UniLoadingButton from "../components/b-patterns/UniLoadingButton";
    import RichTableRecap from "../components/c-blocks/richTableRecap";
    import PopFromBottom from "../components/c-blocks/PopFromBottom";
    import UniInputContainer from "../components/a-elements/UniInputContainer";
    import UniInput from "../components/a-elements/UniInput";
    import InfoMessage from "../components/a-elements/InfoMessage";

    export default {
        name: "payments",
        components: {
            InfoMessage,
            UniInput,
            UniInputContainer,
            PopFromBottom,
            RichTableRecap, UniLoadingButton, BeautifullInputRadio, UniButton, RichTable, LoadingBlock
        },
        computed: {
            ...mapGetters({
                currentFamily: 'currentFamily'
            }),
        },
        props: {},
        data() {
            return {
                openModal: false,
                noCourse: true,
                loading: false,
                family: {
                    email: ''
                },
                isDataLoading: true,
                courses: [],
                isPaymentSectionVisible: false,
                paymentType: '',
                paymentRecurrence: '',
                loadingPrice: false,
                copy: "Copier l'IBAN",
                canCopyText: false,
                ceModal: false,
                buttonCe: false,
                messageSuccess: false,
                loadCe: false
            }
        },
        // watch:{
        //     paymentRecurrence: function(val){
        //         this.paymentType = ''
        //     }
        // },
        methods: {
            hasNoCourses() {
                let total = 0
                this.family.users.forEach(user => {
                    total += user.current_courses.length
                })
                return total === 0
            },
            copyText() {
                navigator.clipboard.writeText("FR76 1027 8035 2500 0825 1174 202")
                    .then(() => {
                        this.copy = 'Copié ! 👌'
                    })
            },
            testIfClipboardPermissionIsOk(){
                navigator.permissions.query({name: 'clipboard-write'})
                    .then(
                        result =>{
                            if (result.state == 'granted' || result.state == 'prompt') {
                                this.canCopyText = true
                            }
                        }
                    )
            },
            createPayment() {
                this.loadingPrice = true
                this.$createPayments(this.family.id, this.paymentType, this.paymentRecurrence)
                    .then(data => {
                        console.log(data)
                        this.family.is_payment_confirmed = true
                        this.family.current_payments = data
                    })

                this.loadingPrice = false
            },
            startPayment() {
                this.openModal = false
                this.isPaymentSectionVisible = true
            },
            downloadCe() {
                this.buttonCe = true

                this.$http.get('/families/' + this.currentFamily.id + '/get-attestation-ce?email=' + this.family.email, this.$getHeaders())
                    .then(response => {

                        this.buttonCe = false
                        this.ceModal = false
                        this.messageSuccess = true
                        window.setTimeout(() => {
                            this.messageSuccess = false
                        }, 5000)
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            },
            openCeModal() {
                this.ceModal = true
            }
        },
        mounted() {
            this.$getModel('families', this.currentFamily.id)
                .then(data => {
                    this.family = data
                    this.$nextTick(() => {
                        this.isDataLoading = false
                        if (!this.hasNoCourses()) {
                            this.noCourse = false
                        }
                    })
                })

            this.testIfClipboardPermissionIsOk()
        }
    }
</script>

<style scoped lang="scss">
    .action-button {
        padding-bottom: 4rem;
    }

    .no-courses {
        > img {
            height: 120px;
            margin-bottom: 24px;
        }

        text-align: center;
        max-width: 400px;
        margin: 1rem auto 0;
    }

    .payment {
        text-align: center;

        img {
            height: 100px;
        }

        h3 {
            margin: 32px 0 16px 0;
        }

        > div {
            text-align: left;
        }
    }

    @include screen-m {
        .action-button {
            padding-bottom: 0;
        }
        .no-courses {
            > img {
                height: 200px;
            }

        }
        .payment {
            img {
                height: 130px;
            }
        }
    }
</style>
